


















import { Component, Vue } from 'vue-property-decorator'
import UserSelect from '@/components/UserSelect/index.vue'
import UserRepositories from '@/components/UserRepositories/index.vue'
import AppConfigs from '@/components/AppConfigs/index.vue'
import { SourceCodeServiceUser } from '@/services/sourceCode/SourceCodeService'

@Component({
  components: {
    UserSelect,
    UserRepositories,
    AppConfigs
  }
})
export default class Home extends Vue {
  userSelected: SourceCodeServiceUser | null = null

  get showRepositories(): boolean {
    return Boolean(this.userSelected?.id)
  }
}
